'use es6';

import * as ActionTypes from './ActionTypes';
export const updateResultsView = value => dispatch => {
  dispatch({
    type: ActionTypes.STOREFRONT_RESULTS_VIEW_UPDATED,
    payload: value
  });
};